import type { ConnectionStatus } from "@/lib/api/types";

export type PillStatus = ConnectionStatus | "testing";

// Der Status steht immer als Text im Pill, die Farbe ist nur Zusatz (CLAUDE.md „Frontend“)
const PILLS: Record<PillStatus, { label: string; className: string }> = {
  connected: { label: "Verbunden", className: "bg-success-bg text-success" },
  warning: { label: "Warnung", className: "bg-warning-bg text-warning" },
  error: { label: "Fehler", className: "bg-danger-bg text-danger" },
  testing: { label: "Teste …", className: "bg-info-bg text-info" },
  untested: { label: "Nicht getestet", className: "bg-info-bg text-info" },
  not_connected: { label: "Nicht verbunden", className: "bg-neutral-bg text-muted" },
};

export const MESSAGE_COLORS: Record<PillStatus, string> = {
  connected: "text-success",
  warning: "text-warning",
  error: "text-danger",
  testing: "text-info",
  untested: "text-info",
  not_connected: "text-muted",
};

export function StatusPill({ status }: { status: PillStatus }) {
  const pill = PILLS[status];
  return (
    <span
      className={`shrink-0 whitespace-nowrap rounded px-2 py-[3px] text-xs font-medium ${pill.className}`}
    >
      {pill.label}
    </span>
  );
}
